<div class="license-manage-modal">
  <div class="modal-header-row">
    <div>
      <h2>{{ modalTitle }}</h2>
      <p>{{ modalDescription }}</p>
    </div>
    <button
      class="modal-close-button"
      type="button"
      data-testid="license-manager-close"
      [attr.aria-label]="'license_manager.actions.close_aria' | translate"
      [disabled]="hasPendingLicenseAssignments"
      [matTooltip]="
        (hasPendingLicenseAssignments
          ? 'license_manager.actions.wait_for_assignments'
          : 'license_manager.actions.close'
        ) | translate
      "
      (click)="close()"
    >
      <span class="icon-close" aria-hidden="true"></span>
    </button>
  </div>

  <div class="modal-body">
    @if (modalView === 'licenses') {
      @if (loading) {
        <div class="modal-status">
          {{ 'license_manager.loading' | translate }}
        </div>
      }

      <div class="license-toolbar">
        <mat-form-field class="license-search-field" appearance="outline">
          <mat-label>{{ 'license_manager.search' | translate }}</mat-label>
          <input
            matInput
            type="text"
            [(ngModel)]="searchText"
            [placeholder]="'license_manager.search' | translate"
          />
        </mat-form-field>

        <button
          class="refresh-license-button"
          type="button"
          [attr.aria-label]="'license_manager.actions.refresh_aria' | translate"
          [disabled]="loading || hasPendingLicenseAssignments"
          [matTooltip]="'license_manager.actions.refresh' | translate"
          (click)="refreshLicenseBatches()"
        >
          <mat-icon>refresh</mat-icon>
        </button>
      </div>

      <div class="license-manage-content">
        <section class="license-section" data-testid="license-manager-linked">
          <div class="section-head">
            <h3>{{ 'license_manager.linked_batches' | translate }}</h3>
            <span>{{ linkedCount }}</span>
          </div>

          @if (!loading && linkedCount === 0) {
            <div class="empty-state">
              {{
                searchText.trim()
                  ? ('license_manager.empty.linked_search' | translate)
                  : ('license_manager.empty.linked' | translate)
              }}
            </div>
          }

          <div class="license-card-list">
            @for (
              batch of filteredLinkedLicenseBatches;
              track trackByBatch($index, batch)
            ) {
              <app-device-license-batch-card
                [batch]="batch"
                mode="linked"
                [processing]="isProcessing(batch)"
                (openDetails)="openBatchDetails(batch)"
                (changeLink)="unlinkBatch(batch)"
              />
            }
          </div>
        </section>

        <section
          class="license-section"
          data-testid="license-manager-available"
        >
          <div class="section-head">
            <h3>{{ 'license_manager.available_licenses' | translate }}</h3>
            <span>{{ availableCount }}</span>
          </div>

          @if (!loading && availableCount === 0) {
            <div class="empty-state">
              {{
                searchText.trim()
                  ? ('license_manager.empty.available_search' | translate)
                  : ('license_manager.empty.available' | translate)
              }}
            </div>
          }

          <div class="license-card-list">
            @for (
              batch of filteredAvailableLicenseBatches;
              track trackByBatch($index, batch)
            ) {
              <app-device-license-batch-card
                [batch]="batch"
                mode="available"
                [processing]="isProcessing(batch)"
                (openDetails)="openBatchDetails(batch)"
                (changeLink)="linkBatch(batch)"
              />
            }
          </div>
        </section>
      </div>
    } @else {
      <app-device-software-override
        [linkedLicenseBatches]="linkedLicenseBatches"
        [deviceId]="data.deviceId"
        [initialArtifactOverrides]="data.artifactOverrides ?? []"
        [initialBundleOverrides]="data.bundleOverrides ?? []"
        [unresolvedOverrideIds]="data.unresolvedOverrideIds ?? []"
        (overridesSaved)="close($event)"
      />
    }
  </div>

  <footer class="modal-footer">
    @if (modalView === 'softwareOverride') {
      <app-button
        class="cancel-navigation-button"
        [small]="true"
        [title]="'software_override.actions.cancel' | translate"
        (click)="showLicenseView()"
      ></app-button>
    }
    @if (data.isMasterAdmin) {
      <app-button
        [small]="true"
        [black]="true"
        [title]="footerActionTitle"
        [disabled]="footerActionDisabled"
        (click)="handleFooterAction()"
      ></app-button>
    }
  </footer>
</div>
